<template>
  <el-row v-if="showPage">
    <el-col
      :xs="{ span: 22, offset: 1 }"
      :sm="{ span: 22, offset: 1 }"
      :md="{ span: 20, offset: 2 }"
      :lg="{ span: 16, offset: 4 }"
      :xl="{ span: 16, offset: 4 }"
    >
      <el-card class="content">
        <h3 class="head-title">{{ $t("detail.title") }}</h3>
        <div style="margin:0 8%">
          <div class="item">
            <i class="el-icon-paperclip"></i>
            <span class="title">{{ $t("detail.title1") }}</span>
            <span>{{ detail.projectName }}</span>
          </div>
          <div class="item">
            <i class="el-icon-paperclip"></i>
            <span class="title">{{ $t("detail.title2") }}</span>
            <span>{{ resolvingDate(detail.createTime) }}</span>
          </div>
          <div class="item">
            <span class="title" style="display:flex;line-height:34px">
              <i class="el-icon-paperclip" style="line-height:34px"></i>
              {{ $t("detail.title3") }}
              <el-progress
                :percentage="this.detail.cfaRate"
                style="width:30%;line-height:34px"
                color="#337ab7"
                v-show="this.detail.cfaRate != 0 && this.detail.cfaRate != 100"
              >
              </el-progress>
              <span @click="toCfaResult" v-show="this.detail.cfaRate == 100">
                <button-secondary>
                  <i class="el-icon-document"
                    >&nbsp;{{ $t("detail.cfareport") }}</i
                  >
                </button-secondary>
              </span>
            </span>
          </div>
          <div class="item">
            <span class="title" style="display:flex;line-height:34px">
              <i class="el-icon-paperclip" style="line-height:34px"></i>
              {{ $t("detail.title4") }}
              <el-progress
                :percentage="this.detail.fullRate"
                style="width:30%;line-height:34px"
                color="#337ab7"
                v-show="this.detail.cfaRate != 0 && this.detail.fullRate != 100"
              >
              </el-progress>
              <span
                @click="toFullModelResult"
                v-show="this.detail.fullRate == 100"
              >
                <button-secondary>
                  <i class="el-icon-document"
                    >&nbsp;{{ $t("detail.fullreport") }}</i
                  >
                </button-secondary>
              </span>
            </span>
          </div>
          <div class="item">
            <i class="el-icon-paperclip"></i>
            <span class="title">{{ $t("detail.title5") }}</span>
            <el-table :data="detail.belongs" height="333px">
              <el-table-column
                align="center"
                type="index"
                :label="$t('detail.tabletitle1')"
                width="200px"
              ></el-table-column>
              <el-table-column
                prop="potential.potentialId"
                :label="$t('detail.tabletitle2')"
              >
                <template slot-scope="scope">
                  <el-tag effect="dark" size="mini" class="potential">{{
                    resolvingPotentialId(scope.row.potential.potentialId)
                  }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                prop="observe.observeId"
                :label="$t('detail.tabletitle3')"
              >
                <template slot-scope="scope">
                  <el-tag effect="dark" size="mini" class="observe">{{
                    resolvingObserveId(scope.row.observe.observeId)
                  }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                prop="factorLoading"
                :label="$t('detail.tabletitle4')"
              ></el-table-column>
            </el-table>
          </div>
          <div class="item">
            <i class="el-icon-paperclip"></i>
            <span class="title">{{ $t("detail.title6") }}</span>
            <span
              v-show="detail.dataPath == undefined || detail.dataPath == '无'"
            >
              <i class="el-icon-document-delete">
                {{ $t("adminDetail.nodata") }}</i
              >
            </span>
            <span
              v-show="detail.dataPath != undefined && detail.dataPath != '无'"
            >
              <span style="margin-right:5px">{{ detail.dataPath }}</span>
              <!-- <span @click="downloadReport">
                <button-secondary>
                  <i class="el-icon-download">{{
                    $t("adminDetail.download")
                  }}</i>
                </button-secondary>
              </span> -->
              <a :href="detail.dataFilePath" class="downloadBtn"
                ><i class="el-icon-download"> {{
                  $t("adminDetail.download")
                }}</i></a
              >
            </span>
          </div>
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import { getProjectDetail, downloadReportApi } from "network/admin";
import ButtonSecondary from "components/body/ButtonSecondary";
export default {
  data() {
    return {
      detail: {
      },
      showPage: false,
    };
  },
  created() {
    getProjectDetail(this.$route.query.id)
      .then((res) => {
        console.log("获取的项目Detail:" + res.data);
        this.detail = res.data;
        this.showPage = true;
      })
      .catch((err) => {
        this.$message.error(this.$t("detail.err1"));
      });
  },
  methods: {
    resolvingObserveId(id) {
      var ob = this.detail.observes;
      var idx = ob.findIndex((value) => value.observeId == id);
      return ob[idx].observeName;
    },
    resolvingPotentialId(id) {
      var ob = this.detail.potentials;
      var idx = ob.findIndex((value) => value.potentialId == id);
      return ob[idx].potentialName;
    },

    //时间转化
    resolvingDate(timestamp) {
      //date是传入的时间
      let d = new Date(timestamp);
      let month =
        d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
      let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
      let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
      let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
      let times =
        d.getFullYear() +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        min +
        ":" +
        sec;

      return times;
    },
    //点击下载数据
    downloadReport() {
      downloadReportApi(this.detail.dataFilePath)
        .then((res) => {
          //如果response headers中content-disposition响应头中获取文件名称fileName
          // let headers = res.headers;
          // let fileName = headers["content-disposition"];
          // fileName = fileName.split("=")[1];
          //或
          //const fileName = decodeURI(res.headers['content-disposition'].split(';')[1].split('filename=')[1]);
          var blob = new Blob([res]);
          var downloadElement = document.createElement("a");
          downloadElement.style.display = "none";
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = "dataFile.xlsx"; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(this.$t("detail.err1"));
        });
    },

    //查看cfa分析报告
    toCfaResult() {
      //console.log(this.$route.query)
      this.$router.push({
        path: "/cfa/result",
        query: { id: this.$route.query.id },
      });
    },

    //查看全模型分析报告
    toFullModelResult() {
      this.$router.push({
        path: "/full/result",
      });
    },
  },
  components: {
    ButtonSecondary,
  },
};
</script>
<style>
.item i {
  margin-right: 5px;
}
.potential.el-tag--dark {
  background-color: #5cb85c;
  border-color: #5cb85c;
}
.observe.el-tag--dark {
  background-color: #5bc0de;
  border-color: #5bc0de;
}
</style>
<style scoped>
.content .item {
  margin: 10px 0;
}
.content .item .title {
  font-weight: 700;
  letter-spacing: 1px;
}
.downloadBtn {
  text-decoration: none;
  padding: 6px 12px;
  color: #333;
  background-color: #fff;
  border-radius: 4px;
  display: inline-block;
  border: 1px solid #ccc;
  font-size: 14px;
  font-weight: 400;
}
.downloadBtn:hover{
  background-color: lightgray;
}
</style>
